import useGetThemesQuery from '@/v2/domains/Themes/queries/useGetThemesQuery.hook';
import constants from '@/v2/domains/Tasks/constants/constants';

export default function useTaskTheme() {
  const { data: themes } = useGetThemesQuery();

  const getTaskTheme = (task) => {
    if (
      task.type == constants.type.template ||
      task.type == constants.type.autopilot
    ) {
      return themes?.find((theme) => theme.id == task.taskTemplate?.themeId);
    } else if (task.type == constants.type.realTime) {
      return getThemeFromTaskActivity(task, themes);
    }

    return null;
  };

  return {
    getTaskTheme,
  };
}

function getThemeFromTaskActivity(task, themes) {
  const activityId = task.taskActivities?.[0].activityId;
  const theme = themes?.find((theme) =>
    theme.activities.some((themeActivity) => themeActivity.id == activityId)
  );
  return theme;
}
